import { Component } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  selector: 'td-wb-nasdaq-basic-fine-print',
  templateUrl: 'nasdaq-basic-fine-print.component.html',
  imports: [
    TranslateDirective
  ]
})
export class NasdaqBasicFinePrintComponent {
  constructor() {}
}
